exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".logo{font-size:60px;letter-spacing:-5px;background-color:#070300;color:transparent;text-shadow:3px 3px 3px hsla(0,0%,100%,.25);-webkit-background-clip:text;background-clip:text}.logo,.subtitle{font-family:Overpass Mono;font-weight:600}.subtitle{color:#606266;font-size:30px;letter-spacing:-4px;margin-top:-20px}a{text-decoration:none;transition:ease-out}#page{font-family:Helvetica Neue,Helvetica,sans-serif;text-align:center}.el-row{margin-bottom:20px;&:last-child{margin-bottom:0}}.el-col{border-radius:4px}.bg-purple-dark{background:#99a9bf}.bg-purple{background:#d3dce6}.bg-purple-light{background:#e5e9f2}.grid-content{border-radius:4px;min-height:36px}.row-bg{padding:10px 0;background-color:#f9fafc}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4837ce5f","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 135
// module chunks = 1